import type { HTMLAttributes, ReactNode, Ref } from 'react';
import type { PrimitiveProps } from './Button';
import { cx } from './cx';
import s from './Mono.module.css';

export interface MonoProps extends PrimitiveProps<HTMLAttributes<HTMLSpanElement>> {
  children: ReactNode;
  /** For a cell or a flex child that must not be widened by a full key id. */
  truncate?: boolean;
  ref?: Ref<HTMLSpanElement>;
}

/**
 * `translate="no"` is written after the spread so no call site can turn it off. Everything
 * that reaches this component is an identifier — a key id, a token prefix, a request id —
 * and one translated by the browser is quoted back to support as a value that never existed.
 */
export function Mono({ children, truncate = false, ...rest }: MonoProps) {
  return (
    <span {...rest} className={cx(s.mono, truncate && s.truncate)} translate="no">
      {children}
    </span>
  );
}

export default Mono;
